import { render, staticRenderFns } from "./AdminResetPasswordInit.vue?vue&type=template&id=7a13b18b"
import script from "./AdminResetPasswordInit.vue?vue&type=script&lang=js"
export * from "./AdminResetPasswordInit.vue?vue&type=script&lang=js"
import style0 from "./AdminResetPasswordInit.vue?vue&type=style&index=0&id=7a13b18b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports